import {Component} from 'panel';

import {getReportUrl} from 'common/report/util';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {NavReport} from '../types';
import {NavigationTrackingEvent} from './tracking';
import template from './index.jade';

export class ReportsMenu extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'current-report-name': `string`,
      open: `boolean`,
      order: `json`,
      'project-id': `number`,
      reports: `json`,
      'two-column': `boolean`,
      'workspace-id': `number`,
    };
  }

  get config() {
    return {
      template,
      helpers: {
        getReportUrl,

        getReports: () => this.attr(`order`).map((r) => this.attr(`reports`)[r]),

        getClassSuffix: (report: NavReport) => {
          // make sure to just use 'messages' from 'triggers/messages' and similar urls
          return (report.endpoint || ``).split(`/`).slice(-1)[0];
        },

        splitReportsInHalf: (reports: NavReport[]) => {
          const sliceIdx = Math.ceil(reports.length / 2);
          return [reports.slice(0, sliceIdx), reports.slice(sliceIdx)];
        },

        handleDropMenuChange: (ev) => {
          ev.stopImmediatePropagation();
          if (ev.detail.state === `closed`) {
            this.setAttribute(`open`, `false`);
            this.dispatchEvent(new CustomEvent(`closemenu`));
          }
        },

        handleClickReportName: (reportName: string) => {
          mixpanel.track(NavigationTrackingEvent.SelectReport, {
            'Nav Source': `Top Nav`,
            'Report From': this.attr(`current-report-name`),
            'Report To': reportName,
          });
        },
      },
    };
  }
}

export const ReportsMenuEl = defineAndMakeJsxFactory(`mp-reports-menu`, ReportsMenu);
